var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgThumbsDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 24
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#151A30",
    d: "M2 5.188v9.375c0 .517.42.937.937.937h3.125c.518 0 .938-.42.938-.938V5.188a.938.938 0 00-.938-.938H2.937A.938.938 0 002 5.188zM3.562 13a.938.938 0 111.876 0 .938.938 0 01-1.876 0zm10.625 10c-.788 0-1.151-1.535-1.325-2.258-.203-.846-.414-1.721-.992-2.3-1.268-1.27-1.934-2.89-3.481-4.419a.468.468 0 01-.139-.333V5.34a.47.47 0 01.46-.469c.619-.011 1.434-.354 2.057-.632 1.24-.552 2.784-1.238 4.67-1.239h.111c1.671 0 3.647.016 4.445 1.162.327.47.408 1.056.24 1.743.637.666.979 1.909.64 2.92.685.916.747 2.193.363 3.104l.005.005c.464.467.762 1.22.759 1.922-.006 1.185-1.022 2.269-2.326 2.269H15.7c.286 1.107 1.3 2.036 1.3 3.693C17 22.688 15.125 23 14.187 23z"
  }))));
}

export default SvgThumbsDown;